import { FleetDefinition } from './../models/FleetDefinition';

export class CreateFleetDefinitionResponse extends FleetDefinition {
}